import { InboxItemDto } from '@bandido/shared/dtos';

import { InboxPage } from './types';

export const dedupeInboxItems = (pages: InboxPage[]) => {
  const byCase = new Map<number, InboxItemDto>();
  pages.forEach(({ items }) => items.forEach((item) => byCase.set(item.caseId, item)));
  return [...byCase.values()];
};
